import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, spacing, breakpoints, fonts, sizes } = redesignTheme;
const contentMaxWidth = sizes.ebookContentMaxWidth;

export const useCustomEbookStyles = makeStyles(() => ({
  page: {
    minHeight: '100vh',
    backgroundColor: colors.background,
    boxSizing: 'border-box',
    scrollBehavior: 'smooth',
    overflowX: 'hidden',
    padding: `${spacing.md}px clamp(${spacing.sm}px, 4vw, 120px) ${spacing.xl}px`,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: `${spacing.md}px 0 ${spacing.xl}px`,
    },
  },
  loadingCenter: {
    minHeight: 'calc(100vh - 80px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.primaryDark,
  },
  readerCard: {
    width: '100%',
    maxWidth: contentMaxWidth,
    margin: '0 auto',
    padding: '40px 40px 20px',
    boxSizing: 'border-box',
    backgroundColor: colors.white,
    color: colors.primaryDark,
    fontFamily: fonts.opensans,
    scrollMarginTop: 96,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      maxWidth: '100%',
      width: '100%',
      padding: `${spacing.md}px ${spacing.sm}px ${spacing.sm}px`,
    },
    '& .ebook-cover': {
      display: 'flex',
      justifyContent: 'center',
      padding: 20,
      borderRadius: 5,
      backgroundColor: '#f4f5ff',
      overflow: 'hidden',
      [`@media (max-width: ${breakpoints.mobile}px)`]: {
        padding: spacing.xs,
      },
    },
    '& .ebook-cover > img': {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
      borderRadius: 5,
      objectFit: 'cover',
    },
  },
  hidden: {
    display: 'none',
  },
  blocks: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    marginTop: spacing.md,
  },
  block: {
    scrollMarginTop: 104,
  },
}));
